export const IDENTIFICACAO = 'Identificação';
export const NOME = 'Nome';
export const VOLTAR = 'Voltar';
export const ATIVIDADES_REQUISICAO = 'Atividades da Requisição';
export const NOTIFICAR_RESPONSAVEIS = 'Notificar Responsáveis';
export const INSIRA_ATIVIDADES = 'Insira as atividades';
export const USUARIOS_ASSOCIADOS = 'Usuários Ativos associados à Requisição ';
